// Branch contact details for booking UI (Shop.phonenumber in DB stores addresses, not phones).
export const SHOP_CONTACTS = {
  1: {
    name: 'Ekamai',
    displayPhone: '02-714-2958',
    tel: '+6627142958',
  },
  2: {
    name: 'Siam Square Outlet',
    displayPhone: '02-252-3989',
    tel: '+6622523989',
  },
  3: {
    name: 'Prompong',
    displayPhone: '097-919-5654',
    tel: '+66979195654',
  },
}

export const getShopContact = (shopId) => {
  const id = parseInt(shopId, 10)
  return SHOP_CONTACTS[id] || null
}



// WEBPACK FOOTER //
// ./src/constants/shop-contacts.js